import AC from '../assets/cards/AC.svg';
import AD from '../assets/cards/AD.svg';
import AH from '../assets/cards/AH.svg';
import AS from '../assets/cards/AS.svg';
import TWOC from '../assets/cards/2C.svg';
import TWOD from '../assets/cards/2D.svg';
import TWOH from '../assets/cards/2H.svg';
import TWOS from '../assets/cards/2S.svg';
import THREEC from '../assets/cards/3C.svg';
import THREED from '../assets/cards/3D.svg';
import THREEH from '../assets/cards/3H.svg';
import THREES from '../assets/cards/3S.svg';
import FOURC from '../assets/cards/4C.svg';
import FOURD from '../assets/cards/4D.svg';
import FOURH from '../assets/cards/4H.svg';
import FOURS from '../assets/cards/4S.svg';
import FIVEC from '../assets/cards/5C.svg';
import FIVED from '../assets/cards/5D.svg';
import FIVEH from '../assets/cards/5H.svg';
import FIVES from '../assets/cards/5S.svg';
import SIXC from '../assets/cards/6C.svg';
import SIXD from '../assets/cards/6D.svg';
import SIXH from '../assets/cards/6H.svg';
import SIXS from '../assets/cards/6S.svg';
import SEVENC from '../assets/cards/7C.svg';
import SEVEND from '../assets/cards/7D.svg';
import SEVENH from '../assets/cards/7H.svg';
import SEVENS from '../assets/cards/7S.svg';
import EIGHTC from '../assets/cards/8C.svg';
import EIGHTD from '../assets/cards/8D.svg';
import EIGHTH from '../assets/cards/8H.svg';
import EIGHTS from '../assets/cards/8S.svg';
import NINEC from '../assets/cards/9C.svg';
import NINED from '../assets/cards/9D.svg';
import NINEH from '../assets/cards/9H.svg';
import NINES from '../assets/cards/9S.svg';
import TENC from '../assets/cards/10C.svg';
import TEND from '../assets/cards/10D.svg';
import TENH from '../assets/cards/10H.svg';
import TENS from '../assets/cards/10S.svg';
import JC from '../assets/cards/JC.svg';
import JD from '../assets/cards/JD.svg';
import JH from '../assets/cards/JH.svg';
import JS from '../assets/cards/JS.svg';
import QC from '../assets/cards/QC.svg';
import QD from '../assets/cards/QD.svg';
import QH from '../assets/cards/QH.svg';
import QS from '../assets/cards/QS.svg';
import KC from '../assets/cards/KC.svg';
import KD from '../assets/cards/KD.svg';
import KH from '../assets/cards/KH.svg';
import KS from '../assets/cards/KS.svg';
import BLUE_BACK from '../assets/cards/BLUE_BACK.svg';

const cardBack = BLUE_BACK;

const cardDeck = [
  AC,
  AD,
  AH,
  AS,
  TWOC,
  TWOD,
  TWOH,
  TWOS,
  THREEC,
  THREED,
  THREEH,
  THREES,
  FOURC,
  FOURD,
  FOURH,
  FOURS,
  FIVEC,
  FIVED,
  FIVEH,
  FIVES,
  SIXC,
  SIXD,
  SIXH,
  SIXS,
  SEVENC,
  SEVEND,
  SEVENH,
  SEVENS,
  EIGHTC,
  EIGHTD,
  EIGHTH,
  EIGHTS,
  NINEC,
  NINED,
  NINEH,
  NINES,
  TENC,
  TEND,
  TENH,
  TENS,
  JC,
  JD,
  JH,
  JS,
  QC,
  QD,
  QH,
  QS,
  KC,
  KD,
  KH,
  KS,
];

export { cardDeck, cardBack };
